function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  stroke: "var(--primary-color, #000)",
  strokeLinecap: "square",
  strokeWidth: 2.632
}, /*#__PURE__*/React.createElement("path", {
  d: "M47.66 17.767c-3.612 0-6.535 2.79-6.535 6.233v2.998h1.697v-2.512c0-2.832 2.168-5.128 4.839-5.128 2.671 0 4.839 2.296 4.839 5.128v2.512h1.696V24c0-3.444-2.922-6.233-6.535-6.233z",
  fill: "none",
  strokeWidth: 1.0000284000000002
}), /*#__PURE__*/React.createElement("path", {
  d: "M40.718 27.01h13.886a.42.42 0 01.42.423v9.699a.42.42 0 01-.42.421H40.718a.42.42 0 01-.421-.421v-9.7a.42.42 0 01.42-.421z",
  fill: "#fff",
  fillRule: "evenodd",
  strokeWidth: 1.0000284000000002
}), /*#__PURE__*/React.createElement("path", {
  d: "M47.66 29.1a1.474 1.474 0 00-.63 2.807V33.74a.42.42 0 00.42.422h.421a.42.42 0 00.421-.422V31.92v-.013a1.474 1.474 0 00-.631-2.807z",
  fill: "none",
  strokeWidth: 1.0000284000000002
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "var(--primary-color, #000)",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1.5 1h53v2h-53zM1.5 52h53v2h-53zM6.5 3h2v49h-2zM16.5 3h2v49h-2zM26.5 3h2v49h-2zM36.5 3h2v49h-2zM46.5 17.752V3h2v14.79m0 1.7v7.519m0 10.705V52h-2V37.724m0-10.714v-7.495"
}));

var SvgJail = function SvgJail(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgJail, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Jail.99ff5ead.svg";
export { ForwardRef as ReactComponent };